// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__dfz9c","errorPage_title":"ErrorPage_errorPage_title__hhZH2","errorPage_buttons":"ErrorPage_errorPage_buttons__YQ5Op"};